import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "notice",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompany();
    await this.search();
  },
  data() {
    return {
      companies: "",
      startDate: dayjs(new Date().setDate(1)).format("YYYY年MM月DD日(ddd)"),
      endDate: dayjs(new Date()).format("YYYY年MM月DD日(ddd)"),
      overtimes: [],
      selectedCompany: localStorage.company_id,
      getCompaniesEnd: false,
      searchEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async search() {
      this.searchEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_NOTICE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.overtimes = res.overtimes;
      this.searchEnd = true;
    },
    dateFormat(targetDate, format) {
      return dayjs(targetDate).format(format);
    }
  }
};
